import { render, staticRenderFns } from "./TrainDetial.vue?vue&type=template&id=40b0740c&scoped=true"
import script from "./TrainDetial.vue?vue&type=script&lang=js"
export * from "./TrainDetial.vue?vue&type=script&lang=js"
import style0 from "./TrainDetial.vue?vue&type=style&index=0&id=40b0740c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b0740c",
  null
  
)

export default component.exports